import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

/**
 * This function fetches raw logs for a particular message ID
 * @param {string} messageId - Id of the message for which raw logs to be fetched
 * @return {Promise} - API response
 */
export const fetchDebugLogs = messageId => {
  const url = `${BASE_URL}debug_logs/${messageId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};
